import { CubeQueryRecord, ExtractorState } from '../types/cubeQueryTypes';

const STORAGE_KEY = 'cube_query_extractor_state';
const QUERIES_KEY = 'cube_query_extractor_queries';

export interface StoredState {
  isRecording: boolean;
  queries: CubeQueryRecord[];
}

export const loadState = (): StoredState => {
  try {
    const savedQueries = localStorage.getItem(QUERIES_KEY);
    const queries: CubeQueryRecord[] = savedQueries ? JSON.parse(savedQueries) : [];

    // Recording depends on a live runtime subscription that cannot survive a
    // page reload, so it must never be restored from storage — otherwise the UI
    // would claim to be recording while nothing is actually intercepted.
    return { isRecording: false, queries };
  } catch {
    return { isRecording: false, queries: [] };
  }
};

export const saveState = (state: ExtractorState): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ isRecording: state.isRecording }));
    localStorage.setItem(QUERIES_KEY, JSON.stringify(state.queries));
  } catch {}
};

export const clearStoredQueries = (): void => {
  try {
    localStorage.setItem(QUERIES_KEY, JSON.stringify([]));
  } catch {}
};
